{
	"imprintTitle": "Impressum",
	"termsAndConditionsTitle": "Termeni și condiții",
	"privacyPolicyTitle": "Politica de confidențialitate",
	"openSourceAttributionTitle": "Atribuire open source"
}
